module.exports = __webpack_public_path__ + "fonts/Flaticon.a278d5a6.ttf";